export default __webpack_public_path__ + "static/media/3.1bca7718.webp";